let linkedInLoaded = false;
let lemlistLoaded = false;

export const loadLinkedInTracking = () => {
  if (linkedInLoaded) return;

  window._linkedin_partner_id = "xxxx";
  window._linkedin_data_partner_ids =
    window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

  document.head.appendChild(script);

  linkedInLoaded = true;
};

export const loadLemlistTracking = () => {
  if (lemlistLoaded) return;

  const script = document.createElement("script");
  script.async = true;
  script.src =
    "https://app.lemlist.com/api/visitors/tracking?k=xxxx";

  document.head.appendChild(script);

  lemlistLoaded = true;
};